/**
 * VisibilitySelector — the public/private choice for game setup.
 *
 * A bare on/off Switch can't convey WHICH direction means "public" — users had
 * to read the label and guess. This renders both choices side by side as a
 * segmented control, so the active option is always highlighted and
 * unmistakable. The setup page's field supplies the "Visibility" label.
 *
 * Tapping the already-selected side is a no-op — onChange only fires on an
 * actual change.
 */

import React from 'react'
import { SetupSegmented } from './setup/SetupSegmented'

export function VisibilitySelector({
  isPublic,
  onChange,
}: {
  isPublic: boolean
  onChange: (isPublic: boolean) => void
}) {
  return (
    <SetupSegmented value={isPublic} onChange={onChange}
      options={[{ value: true, label: 'Public' }, { value: false, label: 'Private' }]} />
  )
}
